import { useCanvasByContext } from "../../store/hook";
import styles from "./index.less";
import classNames from "classnames";
import logo from "../../assets/logo.svg";
import saveSvg from "../../assets/save.svg";
import publishSvg from "../../assets/publish.svg";
import deleteIcon from "../../assets/delete.svg";
import beforeIcon from "../../assets/before.svg";
import nextIcon from "../../assets/next.svg";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { message } from "antd";

const Header = () => {
  const canvas = useCanvasByContext();

  const save = () => {
    const data = canvas.getCanvas();
    if (!data) {
      message.open({
        icon: <CloseCircleOutlined />,
        content: "保存失败!",
      });
    } else {
      message.open({
        icon: <CheckCircleOutlined />,
        content: "保存成功!",
      });
    }
    // console.log("data: ", JSON.stringify(data));
  };

  const publish = () => {
    const data = canvas.getCanvas();
    if (!data) {
      message.open({
        icon: <CloseCircleOutlined />,
        content: "发布失败!",
      });
    } else {
      message.open({
        icon: <CheckCircleOutlined />,
        content: "发布成功!",
      });
    }
  };

  const deleteCanvas = () => {
    canvas.setCanvas(null);
  };

  const goPrevCanvasHistory = () => {
    canvas.goPrevCanvasHistory();
  };

  const goNextCanvasHistory = () => {
    canvas.goNextCanvasHistory();
  };

  return (
    <div className={styles.main}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
        <span>哩叩低代码</span>
      </div>
      <div className={styles.operate}>
        <div className={styles.item} onClick={goPrevCanvasHistory}>
          <img src={beforeIcon} alt="before" />
          <span className={styles.txt}>上一步</span>
        </div>
        <div className={styles.item} onClick={goNextCanvasHistory}>
          <img src={nextIcon} alt="next" />
          <span className={styles.txt}>下一步</span>
        </div>
      </div>
      <div className={classNames(styles.item)} onClick={deleteCanvas}>
        <img src={deleteIcon} alt="delete" />
        <span className={styles.txt}>清空</span>
      </div>
      <div className={classNames(styles.item)} onClick={save}>
        <img src={saveSvg} alt="save" width={25} height={25} />
        <span className={styles.txt}>保存</span>
      </div>
      <div className={classNames(styles.item)} onClick={publish}>
        <img src={publishSvg} alt="publish" width={25} height={25} />
        <span className={styles.txt}>发布</span>
      </div>
    </div>
  );
};

export default Header;
